<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <!-- <input class="form-element__input" :class="classObject" type="text" :placeholder="placeholder" :name="title" autocomplete="off" @keyup="changed" v-model.trim="val"  /> -->
    <currency-input :class="classObject" class="form-element__input" v-model="val" :currency="null" :locale="'tr'" />
    <span class="form-element__icon" :class="{ '-half': isHalf, '-mini': isMini }">TL</span>
    <div class="form-element__message" :class="{ '-error': isError }" v-if="message">{{ message }}</div>
  </div>
</template>

<script>
import { numeric } from '@/directives/'
export default {
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    isError: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    },
    isHalf: {
      type: Boolean,
      default: false
    },
    isBorder: {
      type: Boolean,
      default: false
    },
    isMini: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    classObject: function () {
      let list = {
        '-error': this.isError,
        '-half': this.isHalf,
        '-border': this.isBorder
      }

      return list
    }
  },
  watch: {
    val: function (val) {
      this.$emit('input', val)
    }
  },
  directives: { numeric },
  methods: {
    changed: function (e) {
      // let val = e.target.value.toString().replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      // this.val = val;

      // this.$emit('input', val.replace(/\D/g, ''))

      return e.target.value
    }
  }
}
</script>